import { GlobalState } from 'ha/types/store';

export const getUniversities = (state: GlobalState) =>
  state.search.universities;
